import { useMemo } from 'react';
import { DataTableTabs } from '../../DataTable/DataTableTabs';
import {
  ORDER_SOURCE_STATUS_VALUES,
  DEFAULT_TAB_LABELS,
} from '../types';
import type {
  OrderSourcesTabsProps,
  OrderSourceStatus,
  OrderSourceTab,
  TabsTranslations,
} from '../types';

function buildStatusTabs(translations?: TabsTranslations): OrderSourceTab[] {
  return ORDER_SOURCE_STATUS_VALUES.map((status) => ({
    key: status,
    label: translations?.[status] || DEFAULT_TAB_LABELS[status],
  }));
}

export function OrderSourcesTabs({
  currentStatus,
  onStatusChange,
  disabled = false,
  translations,
  layoutId,
  className,
}: OrderSourcesTabsProps) {
  const tabs = useMemo(() => buildStatusTabs(translations), [translations]);

  return (
    <DataTableTabs<OrderSourceStatus>
      tabs={tabs}
      value={currentStatus}
      onValueChange={onStatusChange}
      disabled={disabled}
      layoutId={layoutId}
      className={className}
    />
  );
}
